import { contentType } from '@shared/const';

export const validateSubtitleLanguages = (episodes) => {
  if (!episodes || !Array.isArray(episodes)) {
    return {
      allNone: false,
      allEnglishOnly: false,
      allNorwegianOnly: false,
      allBoth: false,
      isMixed: true,
    };
  }

  const videoEpisodes = episodes.filter(
    (episode) => episode.contentType !== contentType.GAME
  );

  if (videoEpisodes.length === 0) {
    return {
      allNone: true,
      allEnglishOnly: false,
      allNorwegianOnly: false,
      allBoth: false,
      isMixed: false,
    };
  }

  const subtitleStates = videoEpisodes.map((episode) => {
    const { content } = episode;
    if (!content || !content.subtitles || content.subtitles.length === 0) {
      return { hasNorwegian: false, hasEnglish: false };
    }

    const activeSubtitles = content.subtitles.filter(
      (subtitle) => subtitle?.file?.processingStatus
    );

    if (activeSubtitles.length === 0) {
      return { hasNorwegian: false, hasEnglish: false };
    }

    const languages = activeSubtitles.map((s) => s.language?.code);
    const hasNorwegian = languages.includes('no');
    const hasEnglish = languages.includes('en');

    const willAutoGenerateEnglish = hasNorwegian && !hasEnglish;

    return {
      hasNorwegian,
      hasEnglish: hasEnglish || willAutoGenerateEnglish,
    };
  });

  const allNone = subtitleStates.every(
    (subtitleState) => !subtitleState.hasNorwegian && !subtitleState.hasEnglish
  );
  const allEnglishOnly = subtitleStates.every(
    (s) => !s.hasNorwegian && s.hasEnglish
  );
  const allNorwegianOnly = subtitleStates.every(
    (s) => s.hasNorwegian && !s.hasEnglish
  );
  const allBoth = subtitleStates.every((s) => s.hasNorwegian && s.hasEnglish);

  const isMixed = !allNone && !allEnglishOnly && !allNorwegianOnly && !allBoth;

  return { allNone, allEnglishOnly, allNorwegianOnly, allBoth, isMixed };
};

/**
 * Checks if all video episodes (non-game episodes) have no subtitles
 * @param {Array} episodes - Array of episode objects
 * @returns {boolean|undefined} - true if all video episodes have no subtitles, false if any have subtitles, undefined if no episodes or invalid input
 */
export const hasAllEpisodesWithoutSubtitles = (episodes) => {
  if (!episodes || !Array.isArray(episodes)) {
    return undefined;
  }

  const videoEpisodes = episodes.filter(
    (episode) => episode.contentType !== contentType.GAME
  );

  if (videoEpisodes.length === 0) return false;

  return videoEpisodes.every((episode) => {
    const { content } = episode;
    if (!content || !content.subtitles) {
      return true;
    }
    return content.subtitles.length === 0;
  });
};
